import React from 'react';
import { useRouter } from 'next/router';

import { Page } from '@tager/web-components';
import { FETCH_STATUSES, isServer } from '@tager/web-core';

import { CustomApp_PageContext } from '@/typings/hocs';
import Layout from '@/components/Layout';
import Post from '@/modules/Post';
import {
  getInvestmentThunk,
  getPostThunk,
  getStockThunk,
  selectPostResource,
} from '@/store/reducers/pages/post';
import { getAliasWithoutId, getParamAsString } from '@/utils/common';
import { useTypedSelector } from '@/store/store';
import NotFoundPage from '@/pages/404';
import { getSharedThunkList } from '@/utils/thunks';

function PostPage() {
  const router = useRouter();
  const alias = getParamAsString(router.query.alias);
  const postResource = useTypedSelector((state) =>
    selectPostResource(state, getAliasWithoutId(alias))
  );

  if (!postResource || postResource.status === FETCH_STATUSES.FAILURE) {
    return <NotFoundPage />;
  }

  const { data: post } = postResource;
  return (
    <Page
      title={post?.pageTitle ?? post?.title}
      description={post?.pageDescription ?? post?.excerpt}
      openGraphImage={post?.openGraphImage?.url ?? post?.coverImage?.og?.url}
    >
      <Layout>
        <Post />
      </Layout>
    </Page>
  );
}

PostPage.getInitialProps = async ({
  store,
  query,
  lang,
}: CustomApp_PageContext) => {
  const postAlias = getParamAsString(query.alias);

  const urlAliasWithoutId = getAliasWithoutId(postAlias);

  const requestsPromise = Promise.all([
    ...getSharedThunkList(store.dispatch, lang),
    store.dispatch(getPostThunk(urlAliasWithoutId, lang)).then((post) => {
      if (post?.additionalFields) {
        return Promise.all([
          store.dispatch(getStockThunk(post.additionalFields.stock_id)),
          store.dispatch(
            getInvestmentThunk(post.additionalFields.investment_id)
          ),
        ]);
      }
    }),
  ]);

  if (isServer()) {
    await requestsPromise;
  }

  return {};
};

export default PostPage;
